<div class="flex flex-col gap-2" [formGroup]="formGroup">
    <mat-form-field class="w-full" appearance="outline">
        <mat-label>{{ 'CARD_NUMBER' | translate }} *</mat-label>
        <input class="dark:!text-contrast-yellow" matInput formControlName="cardNumber" />
    </mat-form-field>
    <mat-form-field class="w-full" appearance="outline">
        <mat-label>{{ 'CARD_NAME' | translate }} *</mat-label>
        <input matInput formControlName="name" />
    </mat-form-field>
    <p class="text-old_silver text-xs font-medium dark:text-contrast-yellow">
        {{ 'CARD_NAME_WILL_HELP_WITH_MULTIPLE_CARDS' | translate }}
    </p>
</div>
